import { useState } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router';
import RoundedButtonSecondary from '../../components/button/rounded-button-secondary/RoundedButtonSecondary';
import { trackEvent } from '../../support-and-tracking/analytics-actions';
import { useProject } from '../project-hooks/useProject';
import { getPublishedRewardsForProject } from '../projects-reducer';
import { GiveawayForm } from './GiveawayForm';
import styles from './giveaway-form.module.less';
import { Modal, ModalBlock } from '@sb1/ffe-modals-react';
import { Heading2 } from '@sb1/ffe-core-react';
import { ActionButton } from '@sb1/ffe-buttons-react';

const GiveawayModalForm = ({ modalRef }) => {
    const project = useProject();
    const projectRewards = useSelector((state) => getPublishedRewardsForProject(state, project.id));
    const hasRewards = projectRewards?.length > 0;
    const [success, setSuccess] = useState(false);
    const [error, setError] = useState({});
    const [loading, setLoading] = useState();

    const navigate = useNavigate();
    const receiptText = project?.profile?.giveaway?.receiptText;

    const close = () => {
        setSuccess(false);
        setError({});
        modalRef?.current?.close();
    };

    const modalContent = success ? (
        <div className={styles.modalFinished}>
            <Heading2>Du er med!</Heading2>
            <p className={styles.finishedText}>{receiptText}</p>

            <div className={styles.buttons}>
                <RoundedButtonSecondary
                    onClick={() => {
                        trackEvent('giveaway', 'close');
                        close();
                    }}
                    disabled={loading}
                >
                    Lukk
                </RoundedButtonSecondary>
                <ActionButton
                    onClick={() => {
                        trackEvent('giveaway', 'support');
                        navigate(`/project/${project.id}/${hasRewards ? 'rewards' : 'payment'}`);
                    }}
                >
                    Støtt spleisen
                </ActionButton>
            </div>
        </div>
    ) : (
        <>
            <Heading2>Bli med i trekningen!</Heading2>

            <GiveawayForm
                setSuccess={setSuccess}
                error={error}
                setError={setError}
                loading={loading}
                setLoading={setLoading}
                close={close}
            />
        </>
    );

    return (
        <Modal ref={modalRef}>
            {success && <div className={styles.modalSuccessHeader} />}
            <ModalBlock>{modalContent}</ModalBlock>
        </Modal>
    );
};

export default GiveawayModalForm;
